import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { getAndValidate } from "~/shared/services/api/fetch-client.ts";

const RequestedRateSchema = z.object({
	requestedRateEnabled: z.boolean(),
});

export type RequestedRateResponse = z.infer<typeof RequestedRateSchema>;

async function getRequestedRateFeatureForCustomer(): Promise<RequestedRateResponse> {
	const response = await getAndValidate(
		apiRoutes.GET_REQUESTED_RATE_FEATURE,
		RequestedRateSchema,
	);

	if (!response.success) {
		throw new Error("Failed to fetch requested rate feature");
	}

	return response.data;
}

export function useRequestedRate(customerId: number) {
	const { data, error, isLoading } = useQuery({
		queryKey: ["requested-rate", customerId],
		queryFn: () => getRequestedRateFeatureForCustomer(),
		refetchOnMount: "always",
	});

	return {
		requestedRateFeature: data,
		isLoading,
		error,
	};
}
